// export const LINE_HEIGHT = 20
export const OPEN_BUTTON_TEXT = 'Show more'
export const REDIRECT_BUTTON_TEXT = '...'
export const CLOSE_BUTTON_TEXT = 'Show less'
export const BUTTON_CLASS =
  'toggle-text text-gray-500 font-base hover:underline inline-block text-base font-normal'
export const ELLIPSIS_TEXT = '<span class="text-base font-normal">…  </span>'
